import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import Modal from "react-bootstrap/Modal";
import "./../consultaNominas/consultaNominas.scss";
import { memo } from "react";
import React, { useState } from "react";
import { handleData } from "../../../../utils/HandleUtils";
import { cambiarPasswd } from "../../../services/UsuariosWebService";
import ErrorMessage from "../../../atoms/mensajesError/ErrorMessage";
import Mensaje from "../../../atoms/mensajes/Mensaje";

registerLocale("es", es);

const ModalCambioPasswdUsuariosWeb = (object) => {
  const [mensaje, setMensaje] = useState();

  const [showConfirm] = useState(false);
  const [data, setData] = useState({
    nuevaPasswd: "",
    confirmarPasswd: ""
  })
  const [respuesta, setRespuesta] = useState();

  const actualizaPasswd = (valores) => {
    
    
    if (valores?.nuevaPasswd === null && valores?.nuevaPasswd === "") {
      setMensaje("Debe de indicar la contraseña.")
      
    } else
      if (valores?.confirmarPasswd === null || valores?.confirmarPasswd === "") {
        setMensaje("Debe de indicar la contraseña de nuevo para la confirmación.")
        
      } else
        if (valores?.nuevaPasswd !== valores?.confirmarPasswd) {
          
          setMensaje("Las contraseñas introducidas deben de ser iguales.")
          
        } else {
          cambiarPasswd(valores, object?.niep).then((data) => {
            
            setRespuesta(data)
            // object?.setLoading(true)
            // object?.setBusquedaRealizada(false)
            // getBusquedaModUsuarioPasswd(valores, object?.currentPage, object?.pageSize).then((data) => {
            //     
            //     object?.setListaUsuarios(data)
            //     object?.setTotalPages(data.totalPages);
            //     object?.setBusquedaRealizada(true)
            //     object?.setLoading(false)
            // })
          })
        }

  };


  function modalCambioPasswd() {
    return (
      <Modal
        className={`infModal fechas ${showConfirm ? "opacity-0" : "opacity-100"
          } `}
        show={object.show}
        onHide={object.handleClose}
        backdrop="static"
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {/* <Titulo titulo={"Modificar Contraseña"} tipo={"tituloModal"} /> */}
            <h4 className="tituloModal">Modificar Contraseña</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="caja_formulario col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12 p-3">
            {mensaje !== undefined && mensaje != null ? (<>
              <div className="mb-3">
                <ErrorMessage
                  errorMessage={mensaje}
                  tiempo={3000}
                />
              </div>
            </>) : null}
            {respuesta !== undefined && respuesta != null ? (<>
              <div className="mb-3">
                <Mensaje
                  errorMessage={respuesta}
                  tiempo={3000}
                />
              </div>
            </>) : null}
            <div className="row">
              <div className="col-xxl-12 col-xl-12 col-lg-12">
                <div className="row d-flex justify-content-center mb-2">
                  <div className="col-12 row align-items-center">
                    <label htmlFor="dniAcceso" className="col-5">Nueva Contraseña:</label>
                    <div className="col-7">
                      <input type="text" id="dniAcceso" className="form-control"
                        onChange={(e) => handleData(e.target.value, "nuevaPasswd", setData)}
                      />
                    </div>
                  </div>
                  <div className="col-12 row align-items-center mt-3">
                    <label htmlFor="nombreAcceso" className="col-5">Confirmar Contraseña:</label>
                    <div className="col-7">
                      <input type="text" id="nombreAcceso" className="form-control"
                        onChange={(e) => handleData(e.target.value, "confirmarPasswd", setData)}
                      />
                    </div>
                  </div>

                </div>
                <div className="mensajeAviso p-4">
                  <span>AVISO: Recuerde anotar la nueva contraseña para comunicarselo al usuario final.</span>
                </div>
                <div className="row justify-content-center">

                  <div className="col-6">
                    <button
                      className={`btn rounded p-1`}
                      type="button"
                      onClick={() => actualizaPasswd(data)}
                    >
                      Cambiar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  return <>{modalCambioPasswd()}</>;
};

export default memo(ModalCambioPasswdUsuariosWeb);
